import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { Bounce, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import config from '../config';
import { useTranslation } from 'react-i18next';

const Login = () => {
    const { setClientData } = useAuth();
    const {t}=useTranslation();
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors, isSubmitting },
    } = useForm({
        mode: "onBlur", // This triggers validation when inputs lose focus
    });

    const [loading, setLoading] = useState(false); // Loading state for form submission

    const handleFormSubmit = async (data) => {
        setLoading(true); // Start loading indicator
        try {
            // Call the API to create the client
            const response = await fetch(`${config.apiUrl}/clients/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the content type to JSON
                },
                body: JSON.stringify({
                    username: data.username,
                    password: data.password,
                }),
            });
            // Check if the response status is OK (status code 200)
            if (response.ok) {
                const { isAuthenticated, client } = await response.json();
         
                if (isAuthenticated) {
                    setClientData(client);
                    toast.success(t('loginsuccess'), {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        transition: Bounce,
                    });
                    navigate("/");
                    reset(); // Reset form fields after success
                } else {
                    toast.error(t('loginfail'), {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        transition: Bounce,
                    });
                }
            } else {
                toast.error(t('loginfail'), {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                });
            }
        } catch (error) {
            toast.error(`Error: ${error.message || "Something went wrong"}`, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
        } finally {
            setLoading(false); // Stop loading indicator
        }
    };
    return (
        <div className="min-h-screen bg-[#fdf6ec] flex flex-col items-center justify-start p-0">
            <div className="relative w-[75%] sm:w-[90%] max-[450px]:w-[95%] flex justify-end flex-col items-center  bg-white rounded-t-none rounded-b-3xl  shadow-lg px-4  pt-6 space-y-0">
                <div className="space-y-2 mb-2">
                    <h1 className="text-3xl max-[450px]:text-lg font-bold text-black">{t('welcome')} Delire Perfumes</h1>
            
                </div>

                <div className="space-y-6 w-[85%] max-[450px]:w-[95%]  lg:w-[50%] py-10 ">
                    <h2 className="text-xl font-bold text-[#0a2942]">{t('login')} </h2>
                    <form id="login-form" onSubmit={handleSubmit(handleFormSubmit)}>
                        <div className="space-y-4">
                            <div>
                                <input
                                    type="text"
                                    {...register("username", { required: t('usernamereq') })}
                                    placeholder={t('uem')}
                                    className={`w-full px-4 py-3 rounded-full bg-[#f0f9ff] border-none focus:ring-2 focus:ring-[#47b5ff] ${errors.password ? "border-red-500" : ""
                                        }`}
                                />
                                {errors.username && (
                                    <p className="text-xs text-red-500">
                                        {errors.username.message}
                                    </p>
                                )}
                            </div>

                            <div>
                                <input
                                    type="password"
                                    {...register("password", {
                                        required: t('password'),
                                    })}
                                    placeholder={t('password')}
                                    className={`w-full px-4 py-3 rounded-full bg-[#f0f9ff] border-none focus:ring-2 focus:ring-[#47b5ff] ${errors.password ? "border-red-500" : ""
                                        }`}
                                />
                                {errors.password && (
                                    <p className="text-xs text-red-500">
                                        {errors.password.message}
                                    </p>
                                )}
                            </div>
                         
                            <div className="text-right">
                                <a href="/forget-password" className="text-[#47b5ff] hover:underline">
                                {t('forgotpassword')}</a>
                            </div>
                        </div>
                    </form>

                </div>
                <div className="absolute w-[85%] max-[450px]:w-[80%]   lg:w-[50%] bottom-0 translate-y-1/2 ">
                    <button
                        disabled={isSubmitting || loading}
                        onClick={() =>
                            document
                                .getElementById("login-form")
                                .dispatchEvent(
                                    new Event("submit", { cancelable: true, bubbles: true })
                                )
                        } className="w-full bg-slate-800 hover:bg-[#ff9933] text-white font-bold py-4 max-[450px]:py-2  rounded-full transition duration-200">
                        {t('login')}
                    </button>
                </div>
            </div>
            <div className="text-center mt-9">
                <p className="text-[#0a2942]">
                 {t('noaccount')}   {' '}
                    <a href="/register" className="font-bold hover:underline">
                        {t('signUp')}.
                    </a>
                </p>
            </div>

        </div>
    );
};

export default Login;